<div>
  <gstar-prime-grid
    #grid
    [source]="taxRules().items"
    [totalRows]="taxRules().total"
    [isLoading]="isLoading()"
    [headers]="headers()"
    [settings]="setting"
    (queryChange)="queryHandler($event)">
    <ng-container end-toolbar>
      <div class="mb-2">
        <ap-button
          btnType="primary"
          label="Tax Policy"
          [add]="true"
          (onClick)="addTaxPolicyHandler()"
          icon="plus-outline" />
      </div>
    </ng-container>
  </gstar-prime-grid>
</div>
